(window as any).global = window;

import I18nextLoader from '../i18nextLoader';

export default function defNumberFormat(value: number): string {
    if (Intl.NumberFormat) {
        const numberFormat = new Intl.NumberFormat(I18nextLoader.getInstance().language);
        if (typeof(numberFormat.format) === 'function') {
            return numberFormat.format(value);
        }
    }

    return value.toString();
}
